// The runtime's commands, read from runtime.manifest, the registry blitzcc
// compiles against (see readRuntimeManifest in blitz/libs.cpp). Each line is
//   availability <tab> worker policy <tab> function signature <tab> signature
// where the signature is a command's name and parameters, each with the
// sigil of its type and an optional default, such as
//   Graphics3D%width=-1%height=-1%depth=0%mode=0
//   #EntityX%entity%global=0            (returns a float)
// Availability 0 is an Original command and 1 an Extended one. Names that
// start with an underscore are the compiler's helpers, not commands.

const TYPES = { "%": "Int", "#": "Float", "$": "String", "&": "Long", "@": "Double" };

function parseSignature(signature) {
  let text = signature;
  if (text[0] === "!") text = text.slice(1);
  let returns = null;
  if (TYPES[text[0]]) {
    returns = text[0];
    text = text.slice(1);
  }
  const nameEnd = text.search(/[^A-Za-z0-9_]/);
  const name = nameEnd < 0 ? text : text.slice(0, nameEnd);
  const params = [];
  // Each parameter starts with its sigil; a default may be a quoted string.
  const pattern = /([%#$&@])([A-Za-z0-9_]+)(?:=("(?:[^"]*)"|[^%#$&@]*))?/g;
  for (let match; (match = pattern.exec(text.slice(name.length))); ) {
    params.push({ sigil: match[1], name: match[2], default: match[3] });
  }
  return { name, returns, params };
}

// Returns a Map from each command's lower-case name to
// { name, returns, params: [{sigil, name, default}], extended }.
export function parseManifest(text) {
  const commands = new Map();
  for (const line of text.split(/\r?\n/)) {
    if (!line || line[0] === "#") continue;
    const fields = line.split("\t");
    if (fields.length < 4 || fields[0] === "version") continue;
    const signature = fields[3];
    if (!signature || signature[0] === "_") continue;
    const command = parseSignature(signature);
    if (!command.name) continue;
    command.extended = fields[0] !== "0";
    commands.set(command.name.toLowerCase(), command);
  }
  return commands;
}

export function typeName(sigil) {
  return TYPES[sigil] || "";
}
